import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden py-20 px-4 sm:px-6 lg:px-8" data-id="element-95">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-96">
        <div className="absolute inset-0 bg-gradient-to-b from-warmBrown-dark/80 via-charcoal to-charcoal z-10" data-id="element-97" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,168,83,0.1)_0%,transparent_50%)] z-10" data-id="element-98" />
        {/* Abstract texture/pattern could go here, using a subtle noise or pattern */}
        <div className="absolute inset-0 opacity-[0.03] bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] z-10" data-id="element-99" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="space-y-8 text-left" data-id="element-101">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-warmBrown border border-gold/20 text-gold text-sm font-medium tracking-wide uppercase mb-4" data-id="element-102">
            <span className="relative flex h-2 w-2" data-id="element-103">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" data-id="element-104"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-gold" data-id="element-105"></span>
            </span>
            De tu cocina a tus primeras ventas
          </div>

          <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold tracking-tight text-balance leading-tight" data-id="element-106">
            Transformá algo tan simple como una receta…{' '}
            <br className="hidden md:block" data-id="element-107" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-light italic font-normal" data-id="element-108">
              en dinero real desde tu casa.
            </span>
          </h1>

          <p className="text-xl sm:text-2xl text-cream-muted font-light" data-id="element-109">
            Sin experiencia. Sin inversión grande. Sin vueltas.
          </p>

          <div className="pt-2 pb-4" data-id="element-110">
            <p className="text-2xl font-serif text-gold-light" data-id="element-111">
              "Si podés cocinar… ya tenés un negocio."
            </p>
          </div>

          <div className="flex flex-col items-start gap-4" data-id="element-112">
            <div className="flex items-center gap-3" data-id="element-113">
              <span className="text-xl text-cream-muted/60 line-through" data-id="element-114">
                $33.980
              </span>
              <span className="text-4xl font-bold text-gold" data-id="element-115">
                $16.990 <span className="text-2xl" data-id="element-116">ARS</span>
              </span>
            </div>

            <motion.div whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-block" data-id="element-117">
              <a href="https://lacocinaquevende.shop/cart/53378602205457:1" className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 text-lg font-semibold text-charcoal bg-gold hover:bg-gold-light rounded-full overflow-hidden transition-all duration-300 shadow-[0_0_40px_rgba(212,168,83,0.3)] hover:shadow-[0_0_60px_rgba(212,168,83,0.5)]" data-id="element-118">
                <span className="relative z-10 flex items-center gap-2" data-id="element-119">
                  Quiero empezar hoy
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-120" />
                </span>
                <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-121" />
              </a>
            </motion.div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        x: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative mt-12 lg:mt-0" data-id="element-122">
          <div className="absolute inset-0 bg-gold/20 blur-[60px] rounded-full pointer-events-none" data-id="element-123" />
          <img src="https://cdn.magicpatterns.com/uploads/gDiKgucRP1T9Z2624efsfk/ChatGPT_Image_31_mar_2026,_10_53_59_a.m..png" alt="Pack completo: Ebook en tablet con los 4 bonus" className="relative z-10 w-full h-auto rounded-3xl shadow-[0_0_40px_rgba(0,0,0,0.5)] border border-white/10 object-contain" data-id="element-124" />
        </motion.div>
      </div>
    </section>;
}